//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import carouselSlidesQuery from '~/apollo/queries/home/carousel'
import homeTilesQuery from '~/apollo/queries/home/tiles'
import homeFeaturedQuery from '~/apollo/queries/home/featured'

export default {
  mixins: [seo],
  apollo: {
    carouselSlides: {
      query: carouselSlidesQuery,
      prefetch: true
    },
    homeTiles: {
      query: homeTilesQuery,
      prefetch: true
    },
    homeFeatured: {
      query: homeFeaturedQuery,
      prefetch: true
    }
  },
  watch: {
    carouselSlides (newSlides, oldSlides) {
      // Only randomize when slides first arrive (oldSlides was falsy/empty)
      // Mutating via $set inside this watcher would trigger an infinite loop,
      // so we shuffle a plain copy and reassign once.
      if (newSlides && newSlides.length > 0 && (!oldSlides || oldSlides.length === 0)) {
        this.randomize()
      }
    }
  },
  methods: {
    randomize () {
      // Build a shuffled copy (Fisher-Yates) without mutating the Apollo-cached array.
      const shuffled = this.carouselSlides.slice()
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const temp = shuffled[i]
        shuffled[i] = shuffled[j]
        shuffled[j] = temp
      }
      this.carouselSlides = shuffled
    }
  }
}

